import { styled } from '@abyss/web/tools/styled';

export const alertContainerStyle = (mobileScreen: boolean) => ({
  '&.abyss-alert-root': {
    '.abyss-alert-container': {
      borderWidth: '1px',
      backgroundColor: '#EEF8FB',
      borderColor: '#C3D8F2',
      marginTop: '24px',
      marginRight: mobileScreen ? '8px' : '0px',
      marginLeft: mobileScreen ? '8px' : '0px',
    },
    '.abyss-alert-close-container': {
      height: '20px !important',
      display: 'flex',
      alignItems: 'center',
    },
    '.abyss-alert-close-button': {
      height: '20px',
      width: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      padding: 0,
    },
    '.abyss-alert-close-button-icon': {
      fontSize: '20px',
      height: '20px',
      width: '20px',
      lineHeight: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
});

export const virtualCareProvidersCarouselStyle = {
  'abyss-carousel-root': {
    display: 'flex',
    flexWrap: 'wrap',
    '@screen >= $sm': {
      width: '100%',
      marginTop: '16px',
    },
    '@screen < $sm': {
      width: '100%',
      marginTop: '12px',
    },
  },
  'abyss-carousel-swiper-container': {
    display: 'flex',
    marginBottom: '12px',
    width: '100%',
    willChange: 'transform',
    zIndex: 0,
  },
  'abyss-carousel-slide-container': {
    position: 'relative',
    width: '800px',
    gap: '24px',
    height: 'auto',
    '@screen < $sm': {
      width: '311px',
      gap: '24px',
    },
  },
  'abyss-carousel-minimal-controls': {
    marginTop: '0px',
    padding: '0px',
    height: '20px',
    marginBottom: '20px',
    width: '100%',
    '@screen < $sm': {
      marginBottom: 0,
    },
    'button.abyss-carousel-minimal-pagination-container': {
      padding: ' 0 4px 0 4px',
      display: 'block',
      width: 'auto',
    },
  },
  'abyss-carousel-minimal-nav-icon-right': {
    color:
      'var(--abyss-psx-parcel-colors-carousel-color-background-bullets-isActive) !important',
    width: '20px',
    height: '20px',
  },
  'abyss-carousel-minimal-nav-container-right': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },
  'abyss-carousel-minimal-nav-container-left': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },

  'abyss-carousel-minimal-nav-icon-left': {
    color:
      'var(--abyss-psx-parcel-colors-carousel-color-background-bullets-isActive) !important',
    width: '20px',
    height: '20px',
  },
  'abyss-carousel-minimal-pagination-container': {
    padding: '0 8px 0 8px',
  },
};

export const slideStyleSnack = {
  'abyss-slide-container': {
    backgroundColor: '$white',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
    border: ' 1px solid #E5E5E6',

    visibility: 'visible',
    borderRadius: '8px',
    height: 'auto',
  },
};

export const carouselStyle = (mobileScreen: boolean) => ({
  'abyss-carousel-swiper-container': {
    display: 'flex',
    willChange: 'transform',
    width: 'auto',
    paddingLeft: '3px',
  },
  'abyss-carousel-slide-container': {
    position: 'relative',
    gap: '12px',
    width: mobileScreen ? '155px' : '1054px',
  },
  'abyss-carousel-minimal-controls': {
    marginTop: '8px',
    padding: '0px',
    height: '20px',
    'button.abyss-carousel-minimal-pagination-container': {
      padding: ' 0 4px 0 4px',
      display: 'block',
      width: 'auto',
    },
  },
  'abyss-carousel-minimal-nav-icon-right': {
    width: '20px',
    height: '20px',
  },
  'abyss-carousel-minimal-nav-container-right': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },
  'abyss-carousel-minimal-nav-container-left': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },

  'abyss-carousel-minimal-nav-icon-left': {
    width: '20px',
    height: '20px',
  },
  'abyss-carousel-minimal-pagination-container': {
    padding: '0 8px 0 8px',
  },
});

export const slideStyle = {
  'abyss-slide-container': {
    marginLeft: '0',
    paddingLeft: '0',
    backgroundColor: '$EEF8FB',
  },
};

export const primarySlideStyle = {
  'abyss-slide-container': {
    marginLeft: '0',
    paddingLeft: '0',
    backgroundColor: '$EEF8FB',
    width: '100%',
  },
};

export const slideContainerStyle = {
  'abyss-slide-content-wrapper': {
    padding: '0',
    visibility: 'visible',
  },
};

export const primaryCareSlideContainerStyle = {
  'abyss-slide-content-wrapper': {
    padding: '0',
    visibility: 'visible',
    width: '100%',
  },
};

export const viewAllCardCss = (mobileScreen: boolean) => ({
  border: '1px solid #C3D8F2',
  borderRadius: '8px',
  background: '#fff',
  padding: '16px',
  width: mobileScreen ? '155px' : '160px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
});
export const viewAllCardCssOnMedical = (mobileScreen: boolean) => ({
  border: '1px solid #E5E5E6',
  borderRadius: '8px',
  background: '#fff',
  padding: '16px',
  width: mobileScreen ? '155px' : 'auto',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
});

export const viewAllLinkCss = {
  '.abyss-link-root': {
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 500,
    textAlign: 'center',
    marginLeft: '0px',
  },
};

export const virtualCareProviderCardCss = (
  mobileScreen: boolean,
  primaryCareVirtual: boolean
) => ({
  border: '1px solid #E5E5E6',
  borderRadius: '8px !important',
  background: '#fff',
  padding: '16px',
  width: primaryCareVirtual ? '100%' : mobileScreen ? '155px' : '270px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  height: '100%',
  justifyContent: 'center',
});

export const virtualCareProviderCardText = (mobileScreen: boolean) => ({
  maxWidth: mobileScreen ? '120px' : '146px',
  lineHeight: '18px',
  marginTop: '8px',
  color: '#323333',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '14px',
});

export const virtualCareProviderCardLinkCss = (mobileScreen: boolean) => ({
  'abyss-link-root': {
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 600,
    textAlign: 'center',
    marginLeft: mobileScreen ? '0px' : '4px',
    marginTop: mobileScreen ? '8px' : '0px',
    fontFamily: '$primary',
  },
});
export const virtualCareSpecialityCardCss = (
  fromViewAll: boolean,
  mobileScreen: boolean,
  primaryCareVirtual: boolean
) => ({
  width: fromViewAll
    ? '120px'
    : primaryCareVirtual
    ? '100%'
    : mobileScreen
    ? '140px'
    : '130px',
  height: primaryCareVirtual && 'auto',
});

export const LogoNotAvailableContainer = styled('div', {
  width: '85px',
  height: '35px',
  background: '#F3F3F3',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 4,
  '@media (max-width: 600px)': {
    width: '50px',
    height: 'auto',
  },
});
